export default __webpack_public_path__ + "static/media/en.a334f236.svg";